import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="bg-primary-light/50 pt-24 pb-12 border-t border-primary-dark/5" data-id="element-40">
      <div className="container mx-auto px-6" data-id="element-41">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20" data-id="element-42">
          <div className="lg:col-span-1" data-id="element-43">
            <div className="mb-6" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/gniRXuhgWi11P326tXmzet/accutemp-logo-colour.svg" alt="Accutemp Air Conditioning" className="h-10 w-auto" data-id="element-45" />
            </div>
            <p className="text-xs text-primary-dark/60 leading-relaxed mb-8 max-w-xs" data-id="element-46">
              AccuTemp is Nuneaton's leading commercial HVAC specialist. With
              over 16 years of experience and Daikin D1+ Premier Partner status,
              we deliver installation, maintenance, and compliance services
              built to last.
            </p>
            <button className="bg-primary-dark hover:bg-primary-dark/90 text-white text-sm px-6 py-2.5 rounded-full transition-colors" data-id="element-47">
              Contact us
            </button>
          </div>

          <div data-id="element-48">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-49">
              Services
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-50">
              <li data-id="element-51">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-52">
                  Installation
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-54">
                  Maintenance
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-56">
                  FM & Ad-Hoc Support
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-58">
                  TM44 Compliance
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-60">
                  Knowledge Hub
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-61">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-62">
              Company
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-63">
              <li data-id="element-64">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-65">
                  About AccuTemp
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-67">
                  Accreditations
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-69">
                  Case Studies
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-71">
                  Why choose us
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-accent transition-colors" data-id="element-73">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-74">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-75">
              Contact
            </h4>
            <div className="space-y-5" data-id="element-76">
              <a href="#" className="flex items-start gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-77">
                <img src="https://cdn.magicpatterns.com/uploads/nNB1suhFNGfe5KE3vMugN2/contact-pin.svg" alt="" className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-78" />
                <span data-id="element-79">
                  Unit 7, Bermuda Trade Centre,
                  <br data-id="element-80" />
                  Nuneaton, CV10 7RA
                </span>
              </a>
              <a href="#" className="flex items-center gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-81">
                <img src="https://cdn.magicpatterns.com/uploads/mWtzq8HpugEAB5Agb6tRuc/contact-linkedin.svg" alt="LinkedIn" className="w-5 h-5 flex-shrink-0" data-id="element-82" />
                <span data-id="element-83">Follow us on LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-primary-dark/10 text-xs text-primary-dark/50" data-id="element-84">
          <div className="mb-4 md:mb-0" data-id="element-85">
            Copyright © AccuTemp Air Conditioning Ltd 2026
          </div>
          <div className="flex items-center gap-6" data-id="element-86">
            <a href="#" className="hover:text-primary-dark transition-colors" data-id="element-87">
              Cookies
            </a>
            <a href="#" className="hover:text-primary-dark transition-colors" data-id="element-88">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary-dark transition-colors" data-id="element-89">
              GDPR
            </a>
          </div>
        </div>
      </div>
    </footer>;
}